(function () {
  'use strict';

  var latestUsfProducts = [];
  var usfObserver;
  var renderTimer;

  function syncChoice(wrapper, input) {
    if (!wrapper || !input) return;
    var current = wrapper.querySelector('[data-toff-choice-current]');
    if (current) current.textContent = input.value;
  }

  function initialiseChoices(root) {
    (root || document).querySelectorAll('.toff-choice-wrapper').forEach(function (wrapper) {
      var checked = wrapper.querySelector('input[data-variant-input]:checked');
      syncChoice(wrapper, checked);
    });
  }

  function optionType(name) {
    var normalised = String(name || '').toLowerCase();
    if (normalised === 'case' || normalised.indexOf('case colour') !== -1 || normalised.indexOf('case color') !== -1) return 'case';
    if (normalised === 'strap' || normalised.indexOf('strap colour') !== -1 || normalised.indexOf('strap color') !== -1) return 'strap';
    return '';
  }

  function valueText(option, variantValue) {
    if (typeof variantValue === 'number' && option.values[variantValue] !== undefined) return option.values[variantValue];
    if (option.values[variantValue] !== undefined) return option.values[variantValue];
    return variantValue;
  }

  function handleise(value) {
    return String(value || '').toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }

  function variantForValue(product, option, optionIndex, value) {
    var variants = product.variants || [];
    var availableMatch;
    var anyMatch;

    for (var i = 0; i < variants.length; i += 1) {
      var variant = variants[i];
      var variantText = valueText(option, variant.options && variant.options[optionIndex]);
      if (String(variantText) !== String(value)) continue;
      if (!anyMatch) anyMatch = variant;
      if (variant.available !== false) {
        availableMatch = variant;
        break;
      }
    }

    return availableMatch || anyMatch;
  }

  function createUsfColourRows(product) {
    var wrapper = document.createElement('div');
    wrapper.className = 'toff-grid-colours toff-grid-colours--usf';

    (product.options || []).forEach(function (option, optionIndex) {
      var type = optionType(option.name);
      if (!type || !option.values || option.values.length < 2) return;

      var row = document.createElement('div');
      row.className = 'toff-grid-colour-row';
      row.setAttribute('aria-label', option.name + ' colours');

      var label = document.createElement('span');
      label.className = 'toff-grid-colour-label';
      label.textContent = option.name;
      row.appendChild(label);

      var swatches = document.createElement('div');
      swatches.className = 'toff-grid-colour-swatches';

      option.values.slice(0, 6).forEach(function (value, valueIndex) {
        var variant = variantForValue(product, option, optionIndex, value);
        if (!variant) return;

        var link = document.createElement('a');
        link.className = 'toff-grid-colour-swatch toff-colour--' + handleise(value);
        if (valueIndex === 0) link.classList.add('is-selected');
        if (variant.available === false) link.classList.add('is-unavailable');
        link.href = '/products/' + product.urlName + '?variant=' + variant.id + '&toff_variant=' + variant.id;
        link.setAttribute('aria-label', product.title + ' — ' + option.name + ': ' + value);
        link.setAttribute('title', option.name + ': ' + value);

        var hidden = document.createElement('span');
        hidden.className = 'visually-hidden';
        hidden.textContent = value;
        link.appendChild(hidden);
        swatches.appendChild(link);
      });

      if (option.values.length > 6) {
        var more = document.createElement('span');
        more.className = 'toff-grid-colour-more';
        more.textContent = '+' + (option.values.length - 6);
        swatches.appendChild(more);
      }

      row.appendChild(swatches);
      wrapper.appendChild(row);
    });

    return wrapper;
  }

  function renderUsfColours() {
    if (!latestUsfProducts.length) return;
    if (usfObserver) usfObserver.disconnect();
    try {
      latestUsfProducts.forEach(function (product) {
      var card = document.querySelector('[data-usf-pid="' + product.id + '"]');
      if (!card) return;

      var existing = card.querySelector('.toff-grid-colours--usf');
      if (existing) existing.remove();

      var rows = createUsfColourRows(product);
      if (!rows.children.length) return;

      var content = card.querySelector('.grid-product__content') || card;
      content.appendChild(rows);
      });
    } finally {
      var container = document.getElementById('usf_container');
      if (usfObserver && container) {
        usfObserver.observe(container, { childList: true, subtree: true });
      }
    }
  }

  function scheduleUsfRender() {
    clearTimeout(renderTimer);
    renderTimer = setTimeout(renderUsfColours, 80);
  }

  function attachUsf(attempt) {
    if (window.usf && window.usf.event && typeof window.usf.event.add === 'function') {
      window.usf.event.add('sr_updated', function (search, data) {
        latestUsfProducts = data && data.items ? data.items : [];
        scheduleUsfRender();
      });

      var container = document.getElementById('usf_container');
      if (container && window.MutationObserver && !usfObserver) {
        usfObserver = new MutationObserver(scheduleUsfRender);
        usfObserver.observe(container, { childList: true, subtree: true });
      }
      return;
    }

    if (attempt < 80) {
      setTimeout(function () { attachUsf(attempt + 1); }, 250);
    }
  }

  function applyRequestedVariant() {
    var params = new URLSearchParams(window.location.search);
    var requestedId = params.get('toff_variant');
    if (!requestedId) return;

    var section = document.querySelector('.product-section[data-section-type="product"]');
    var variantsJson = section && section.querySelector('[data-variant-json]');
    if (!section || !variantsJson) return;

    var variants;
    try { variants = JSON.parse(variantsJson.value || variantsJson.textContent); } catch (ignore) { return; }
    var requested = variants.find(function (variant) { return String(variant.id) === String(requestedId); });
    if (!requested) return;

    var changedInput = null;
    (requested.options || []).forEach(function (value, index) {
      var inputs = section.querySelectorAll('input[data-variant-input][data-index="option' + (index + 1) + '"]');
      Array.prototype.forEach.call(inputs, function (input) {
        var matches = String(input.value) === String(value);
        input.checked = matches;
        if (matches) changedInput = input;
      });
    });

    var masterSelect = section.querySelector('select[name="id"]');
    if (masterSelect) masterSelect.value = String(requested.id);
    if (changedInput) changedInput.dispatchEvent(new Event('change', { bubbles: true }));
  }

  document.addEventListener('change', function (event) {
    if (!event.target.matches('.toff-choice-wrapper input[data-variant-input]')) return;
    syncChoice(event.target.closest('.toff-choice-wrapper'), event.target);
  });

  /* Some collection/search scripts intercept card clicks. Keep each colour
     swatch as a reliable direct link to the matching product variant. */
  document.addEventListener('click', function (event) {
    var swatch = event.target.closest && event.target.closest('a.toff-grid-colour-swatch');
    if (!swatch || !swatch.href) return;
    event.preventDefault();
    event.stopPropagation();
    window.location.href = swatch.href;
  }, true);

  document.addEventListener('page:loaded', function () {
    initialiseChoices(document);
    attachUsf(0);
    window.setTimeout(applyRequestedVariant, 0);
  });
  document.addEventListener('quickview:loaded', function () { initialiseChoices(document); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initialiseChoices(document);
      attachUsf(0);
      window.setTimeout(applyRequestedVariant, 0);
    });
  } else {
    initialiseChoices(document);
    attachUsf(0);
    window.setTimeout(applyRequestedVariant, 0);
  }
})();

